import axios from "../api/axiosInstance";


export const GetAllUser = async () => {
    return await axios.get("/User/GetUserList");
};

export const AddUser = async (model) => {
    return await axios.post("/User/AddUser", model);
};

export const UpdateUser = async (model) => {
    return await axios.post("/User/UpdateUser", model);
};

export const GetByEmployeeId = async (employeeId) => {
    return await axios.get("/User/GetByEmployeeId", {
        params: { employeeId },
    });
};

export const GetUserByUserName = async (userName) => {
    return await axios.get("/User/GetUserByUserName", {
        params: { userName },
    });
};
export const GetUserByEmployeeId = async (employeeId) => {
    return await axios.get("/User/GetUserByEmployeeId", {
        params: { employeeId },
    });
};



